export default "__VITE_ASSET__Bj7NmF1D__"